import ScenarioProvider from './scenarioProvider';

export const getScenarioPreviewAsync = ScenarioProvider.getScenarioPreviewAsync;

export const getScenarioByVesselTypeAsync = ScenarioProvider.getScenarioByVesselTypeAsync;

export const updateScenarioAsync = ScenarioProvider.updateScenarioAsync;

export const insertScenarioAsync = ScenarioProvider.insertScenarioAsync;

export const getAllScenarioPreviewAsync = ScenarioProvider.getAllScenarioPreviewAsync;

export const getScenarioByIdAsync = ScenarioProvider.getScenarioByIdAsync;
